import {
  BottomSheet,
  BottomSheetIllustrationContent,
  type UseModalState,
} from "@clipboard-health/ui-components";
import { useCallback } from "react";

import { BottomSheetHeader } from "./BottomSheetHeader";
import { Button } from "./Button";
import { DialogFooter } from "./DialogFooter";

interface CameraPermissionErrorBottomSheetProps {
  modalState: UseModalState;
  onGoToSettings: () => Promise<void>;
}

export function CameraPermissionErrorBottomSheet(props: CameraPermissionErrorBottomSheetProps) {
  const { modalState, onGoToSettings } = props;

  const handleClose = useCallback(() => {
    modalState.closeModal();
  }, [modalState]);

  return (
    <BottomSheet
      footer={
        <DialogFooter orientation="vertical">
          <Button fullWidth variant="contained" size="large" onClick={onGoToSettings}>
            Go to settings
          </Button>
        </DialogFooter>
      }
      header={<BottomSheetHeader onClose={handleClose} />}
      modalState={modalState}
    >
      <BottomSheetIllustrationContent
        illustrationType="document-rejected"
        title="Camera permission denied"
        description="Please share camera access with Clipboard in device settings to continue."
      />
    </BottomSheet>
  );
}
